import banarash1 from "./Banarash/1576712446222_IMG_20180513_183256.jpg"
import banarash2 from "./Banarash/banaras 4.jpg"
import camera1 from "./Camera/1749223741047.webp"
import camera2 from "./Camera/1749223741057.jpg"
import camera3 from "./Camera/Photo.webp"
import camera5 from "./Camera/1749824497372.jpg"
import camera6 from "./Camera/diwl.jpeg"
import camera7 from "./Camera/kufr.jpeg"
import camera8 from "./Camera/kufri.jpeg"
import camera9 from "./Camera/ldr.jpeg"
import camera10 from "./Camera/mans.jpeg"
import camera11 from "./Camera/punr.jpeg"
import camera12 from "./Camera/shukhna.jpeg"
import camera13 from "./Camera/shukn.jpeg"
import college1 from "./College/DSC05379.JPG"
import college2 from "./College/DSC05392.JPG"
import college3 from "./College/IMG-20191223-WA0010.jpg"
import college4 from "./College/IMG_20200306_230156.jpg"
import college5 from "./College/Screenshot 2025-06-06 205655.png"
import college6 from "./College/WhatsApp Image 2023-01-16 at 20.17.40.jpg"
import company1 from "./company/Walkwel group photo.jpg"
import company2 from "./company/1749824497348.jpg"
import haridwar1 from "./Haridwar/1739077338267.JPG"
import haridwar2 from "./Haridwar/1739093453750.JPG"
import rishikesh1 from "./Rishikesh/1739077338236.jpg"
import rishikesh2 from "./Rishikesh/1739077338247.JPG"
import rishikesh3 from "./Rishikesh/1739077338256.JPG"
import rishikesh4 from "./Rishikesh/1739077338316.JPG"
import rishikesh5 from "./Rishikesh/1739077338354.JPG"
import rishikesh6 from "./Rishikesh/1739166434792.JPG"
import rockGarden1 from "./Rockgarden/20250216_131703.jpg"
import rockGarden2 from "./Rockgarden/20250216_132420.jpg"
import rockGarden3 from "./Rockgarden/20250216_132738.jpg"
import rockGarden4 from "./Rockgarden/IMG_2984.JPG"
import rockGarden5 from "./Rockgarden/IMG_3018.JPG"
import rockGarden6 from "./Rockgarden/IMG_3048.JPG"
import rockGarden7 from "./Rockgarden/IMG_3076.JPG"
import solan1 from "./Solan/1728142152855.jpg"
import solan2 from "./Solan/IMG-20241002-WA0017.jpg"
import solan3 from "./Solan/1760279269749.png"
import sukhnaLake1 from "./Sukhna-lake/IMG_2919.JPG"
import sukhnaLake2 from "./Sukhna-lake/20250216_122736.jpg"
import kasuali1 from "./Kasauli/IMG_20250624_081555_501.jpg"
import kasuali2 from "./Kasauli/IMG_20250624_081555_646.jpg"
import kasuali3 from "./Kasauli/IMG_20250624_081555_720.jpg"
import kasuali4 from "./Kasauli/IMG_20250624_081555_791.jpg"
import pinjore from "./MorniHils/1754835150149.jpg"
import mornihils from './MorniHils/1754834339425.jpg'
import shimla1 from './shimla/1776278209475.jpg'
import shimla2 from './shimla/1776278209499.jpg'
import shimla3 from './shimla/1776278209513.png'



export const images = [
    { link: college1, isDeleted: false },
    { link: college2, isDeleted: false },
    { link: college4, isDeleted: false },
    { link: college5, isDeleted: false },
    { link: college6, isDeleted: false },
    { link: company1, isDeleted: false },
    { link: rockGarden1, isDeleted: false },
    { link: banarash1, isDeleted: false },
    { link: banarash2, isDeleted: false },

    { link: camera7, isDeleted: false },
    { link: camera13, isDeleted: false },
    { link: camera10, isDeleted: false },
    
    { link: shimla3, isDeleted: false },
    { link: shimla1, isDeleted: false },
    { link: shimla2, isDeleted: false },

    { link: camera1, isDeleted: false },
    { link: college3, isDeleted: false },
    { link: camera3, isDeleted: false },
    { link: haridwar2, isDeleted: false },
    { link: haridwar1, isDeleted: false },
    { link: rishikesh1, isDeleted: false },
    { link: sukhnaLake1, isDeleted: false },
    { link: rishikesh2, isDeleted: false },
    { link: solan1, isDeleted: false },
    { link: kasuali4, isDeleted: false },
    { link: kasuali2, isDeleted: false },
    { link: kasuali3, isDeleted: false },
    { link: rishikesh6, isDeleted: false },
    { link: rishikesh4, isDeleted: true },
    { link: camera8, isDeleted: false },
    { link: rishikesh5, isDeleted: true },
    { link: camera12, isDeleted: false },
    { link: rockGarden2, isDeleted: false },
    { link: kasuali1, isDeleted: false },
    { link: rockGarden3, isDeleted: false },
    { link: rockGarden4, isDeleted: true },
    { link: rockGarden5, isDeleted: false },
    { link: rockGarden6, isDeleted: false },
    { link: rockGarden7, isDeleted: false },
    { link: sukhnaLake2, isDeleted: false },
    { link: camera2, isDeleted: false },
    { link: rishikesh3, isDeleted: false },
    { link: rishikesh6, isDeleted: false },
    { link: solan2, isDeleted: false },
    { link: camera5, isDeleted: false },

    // remove haridwar2, rishikesh6 already above
    { link: company2, isDeleted: false },
    { link: mornihils, isDeleted: false },
    { link: haridwar2, isDeleted: false },
    { link: solan3, isDeleted: false },
    { link: pinjore, isDeleted: false },
    { link: rishikesh6, isDeleted: false },

    { link: camera6, isDeleted: false },
    { link: camera12, isDeleted: false },
    { link: camera9, isDeleted: true },
    { link: camera11, isDeleted: false },

  ];
  
